import React from 'react'
import PropTypes from 'prop-types'
import clsx from 'clsx'
import { makeStyles } from '@material-ui/core/styles'
import Icon from '../../../../../atoms/Icon'
import useStatusImageUrl from '../hooks/useStatusImageUrl'

const useStyles = makeStyles(() => ({
  pill: {
    height: '100%',
    cursor: 'pointer',
    background: 'none',
    border: 'none',
    borderBottom: '2px solid transparent',
    padding: '0 var(--dim-1)',
    color: 'inherit',
    '&.__active': {
      borderBottom: '2px solid var(--color-primary-500)'
    }
  },
  icon: ({ color }) => ({
    width: '26px',
    height: '26px',
    padding: '5px',
    boxSizing: 'border-box',
    flexShrink: 0,
    backgroundColor: color ? `color-mix(in srgb, ${color} 30%, white)` : 'transparent',
    '& svg': { fill: color, display: 'block' }
  }),
  count: {
    backgroundColor: 'var(--color-neutral-200)',
    padding: 'var(--dim-1)',
    fontSize: '0.75em',
    minWidth: '2em'
  }
}))

function FilterPill ({ style, icon, label, count, active, onClick }) {
  const classes = useStyles({ color: style?.color })
  const resolvedImageUrl = useStatusImageUrl(style)
  return (
    <button
      type='button'
      className={clsx(classes.pill, 'flex items-center font-size-sm relative', { __active: active })}
      style={{ gap: '0.5em' }}
      onClick={onClick}
    >
      <span className={clsx(classes.icon, 'inline-flex items-center justify-center radius-md')}>
        {resolvedImageUrl
          ? <img src={resolvedImageUrl} alt='' aria-hidden='true' style={{ width: '16px', height: '16px', objectFit: 'contain', display: 'block' }} />
          : <Icon name={icon || style?.icon} customSize={16} color={style?.color || '#000'} />}
      </span>
      <span className='font-light'>{label}</span>
      <span className={clsx(classes.count, 'radius-md text-center')}>{count}</span>
    </button>
  )
}

FilterPill.propTypes = {
  style: PropTypes.shape({
    color: PropTypes.string,
    icon: PropTypes.string,
    imageUrl: PropTypes.string,
    imageId: PropTypes.string
  }),
  icon: PropTypes.string,
  label: PropTypes.string.isRequired,
  count: PropTypes.number.isRequired,
  active: PropTypes.bool,
  onClick: PropTypes.func.isRequired
}

export default FilterPill
